import {
  DashboardOverviewData,
  PostDataDashboardProps,
} from '@frontend/sorghum/interface';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { DATA_DASHBOARD_OVERVIEW } from '../apis';

const defaultValue = {
  uniqNewUsers: 0,
  lastUniqNewUsers: 0,
  uniqNewUsersTrend: 0,
  uniqRnSubscribers: 0,
  lastUniqRnSubscribers: 0,
  uniqRnSubscribersTrend: 0,
  uniqActiveUsers: 0,
  lastUniqActiveUsers: 0,
  uniqActiveUsersTrend: 0,
} as DashboardOverviewData;

async function postDataDashboardOverviewData(
  projectID: string,
  params: PostDataDashboardProps,
): Promise<DashboardOverviewData> {
  return axios
    .post(`${DATA_DASHBOARD_OVERVIEW}?projectId=${projectID}`, params)
    .then((res) => res.data.data)
    .catch((err) => defaultValue);
}

export function usePostDataDashboardOverviewData(projectID: string) {
  return useMutation({
    mutationKey: ['post-data-dashboard-overview-data'],
    mutationFn: (props: PostDataDashboardProps) => {
      return postDataDashboardOverviewData(projectID, props);
    },
  });
}

export default usePostDataDashboardOverviewData;
